import { css, injectGlobal } from 'styled-components';
import { media } from './utils';
import { grey } from './colors';

export const maxWidth = 1280;
export const gutterWidth = '5rem';

export const headerHeight = {
    desktop: 100,
    laptop: 80,
    phone: 100,
    phoneSticky: 80
}

injectGlobal`
    html,
    body {
        margin: 0;
        padding: 0;
        height: 100%;
        width: 100%;
        background: white;
        color: black;
        font-family: 'Scto', Arial, sans-serif;
        font-weight: 300;
        -webkit-font-smoothing: antialiased;

        /* Rem units */

        font-size: 8px;

        ${media.laptop`
            font-size: 6px;
        `}
    }

    a {
        text-decoration: none;
    }

    a, p, div {
        color: ${grey};
    }

    p {
        margin: 0;
    }

    b, strong {
        font-weight: 500;
    }

    * {
        -webkit-overflow-scrolling: touch;
    }
`;

export const padding = css`
    padding-left: 60px;
    padding-right: 60px;
    box-sizing: border-box;

    ${media.phone`
        padding-left: 40px;
        padding-right: 40px;
    `}
`

export const container = css`
    width: ${maxWidth}px;
    max-width: 100%;
`

export const innerContainer = css`
    width: 920px;
    max-width: 100%;

    ${media.laptop`
        width: 720px;
    `}

    ${media.tablet`
        width: 100%;
        ${padding};
    `}
`

export const hoverState = css`
    transition: 0.15s opacity ease;

    &:hover {
        opacity: 0.7;
    }
`

export const bgImage = css`
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
`

export const bgIcon = css`
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
`

export const videoEmbed = css`
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
    max-width: 100%;
    height: auto;

    iframe, object, embed {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
`

export const remUnit = 8;
export const remUnitTablet = 6;


// WEBPACK FOOTER //
// ./src/styles/global.js